import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import { connect } from 'react-redux';

import CustomSelection from './CustomSelection';
import { format } from 'date-fns';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import CustomModal from './CustomModal';
import utils from '../lib/utils';
import ConfirmationModal from './ConfirmationModal';

const ReleaseDisplayNotes = ({ releaseDisplayArr, latestEdit, onDeleteReleaseNote }) => {
  const [htmlText, setHtmlText] = useState('');
  const [releaseNoteId, setReleaseNoteId] = useState('');

  const [releaseModal, setReleaseModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [confirmationBodyText, setConfirmationBodyText] = useState('');
  const [warningModal, setWarningModal] = useState(false);
  const token = localStorage.getItem('jwtToken');


  const onDisplayRelease = (item, index) => {
    console.log(item._id)
    setReleaseNoteId(item._id)
    const htmlText = item.htmlText === '' ? '<p><b>Empty Message</b></p>' : item.htmlText;
    const contentBlock = htmlToDraft(htmlText);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      setHtmlText(editorState);
      setReleaseModal(true);
    }
  };

  const onDeleteSubmit = async (id) => {
    setConfirmationBodyText(`You are about to delete this release note. Are you sure you want to proceed?`);
    setWarningModal(true);
  }

  const onDeleteConfirm = async (id) => {
    await onDeleteReleaseNote(id);
    setWarningModal(false);
    setReleaseModal(false);
   
  }


  const onEdit = () => {
    latestEdit(releaseDisplayArr[0]);
  };
  return (
    <>
      <Row>
        <Col md={6} sm={12}>
          {releaseDisplayArr.map((item, index) => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Button color="link" className="float-left" onClick={() => onDisplayRelease(item, index)}>
                  {utils.getDateTimeFormat(item.publishDate, 'regular')} {item.title}
                </Button>
                {index === releaseDisplayArr.length - 1 ? null : (
                  <div
                    style={{
                      height: '25px',
                      width: '1px',
                      backgroundColor: 'black',
                      margin: '5px 0 10px 0',
                    }}
                  />
                )}
              </div>
            );
          })}
        </Col>
      </Row>
      <CustomModal
        header="Release Note"
        onConfirm={activeIndex === 0 ? onEdit : null}
        confirmBtnText="Edit"
        submitDisplay
        isOpen={releaseModal}
        onCancel={() => setReleaseModal(false)}
        onDelete={() => onDeleteSubmit(releaseNoteId)} // Pass a function here
        >
        <Editor toolbarHidden editorState={htmlText} readOnly />
      </CustomModal>
      <ConfirmationModal
        isOpen={warningModal}
        onCancel={() => setWarningModal(false)}
        onConfirm={() => onDeleteConfirm(releaseNoteId)} 
        bodyText={confirmationBodyText}
        confirmBtnText="Continue"
        headerText="Confirm Release Note Delete"
        customButtomColor={'danger'}
      />
    </>
  );
};


const mapStateToProps = state => ({
  openModal: state.UIState.profile.openResetPassModal,
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReleaseDisplayNotes);

